<grid-engine-header-shell [params]="params()">
  <mat-icon [svgIcon]="$safeNavigationMigration(params()?.headerIcon)" class="header-icon" />
  @if (params()?.showHeaderName) {
    <span class="capitalize-first-letter" [ngClass]="{ 'skip-text-transform': $safeNavigationMigration(params()?.skipTextTransform) }">{{
      $safeNavigationMigration(params()?.displayName) | translate
    }}</span>
  }
</grid-engine-header-shell>
